<template>
    <BookmarkPopup :height="417" :isShowBookmarkPopup="isOpen" :closeBookmarkPopup="closeModal">
        <div>
            <div @click="closeModal" style="font-weight: 700;">닫기</div>
            <div style="margin-top: 18px; text-align: center;">
                <img style="width: 150px;" :src="require('@/assets/img/not_expert.png')" alt="">
            </div>
            <div style="margin-top: 20px; font-size: 20px; line-height: 24px; font-weight: 700; text-align: center;">전문가 인증이 진행되지 않았습니다<br>전문가 인증을 진행해주세요!</div>
            <div style="padding:16px 0px; text-align:center; color:white; font-size:12px;">
                <div>실수로 전문가 회원으로 가입하신 경우,</div>
                <div style="margin-top:8px;">탈퇴 후 일반 회원으로 다시 가입하시면 정상적으로 활동하실 수 있습니다.</div>
            </div>
            <div style="display: flex; gap: 12px;">
                <div @click="closeModal" style="flex: 1; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #fff; font-size: 14px; font-weight: 700;">나중에 하기</div>
                <div @click="showInquiryPopup" style="flex: 1; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; ">지금 인증하기</div>
            </div>
        </div>
    </BookmarkPopup>
</template>

<script>
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import WebPushManager from '@/modules/WebPushManager'
import ResponseCode from '@/ResponseCode';
import { MEMBER_TYPE, JOIN_CHAT_TYPE } from '@/Constants'

const WEB_PUSH_TOKEN = 'WEB_PUSH_TOKEN';
const WEB_PUSH_TOKEN_STATE = 'WEB_PUSH_TOKEN_STATE';

export default {
    name: 'NotExpert',
    components: { BookmarkPopup },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeModal: {
            type: Function,
            default: () => { }
        }
    },
    methods: {
        async showInquiryPopup() {
            this.closeModal()
            this.openChatCoachAndAdmin()
            // if (this.$Util.isApp()) {
            //     await this.$Util.showChatWithAdmin();
            // } else {
            //     if (this.$hasOwnProperty(localStorage, WEB_PUSH_TOKEN)
            //         && (this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'nologin')
            //         && (!this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'login')
            //     ) {
            //         await this.$Util.showChatWithAdmin();
            //         this.closeModal()
            //     } else {
            //         const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">PUSH알림을 허용해주세요.</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>브라우저 PUSH알림을 잠깐만 켜두시면<br>더 빠르고 원활하게 답변을 받을 수 있어요</div>`
            //         this.$GlobalStore.showConfirm(html, this.openChatCoachAndAdmin, '확인', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
            //     }
            // }
        },
        async checkPermssion() {
            let [isSuccess, token] = await WebPushManager.requestPermission();
            if (isSuccess) {
                const parameters = {};
                parameters.token = token;
                const res = await this.$Axios.post('/api/nologin/device/push/set', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    localStorage.setItem(WEB_PUSH_TOKEN, token);
                    localStorage.setItem(WEB_PUSH_TOKEN_STATE, this.$GlobalStore.isLogin() ? 'login' : 'nologin');
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        async openChatCoachAndAdmin() {

            await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
        },
        async showChatting() {
            await this.checkPermssion();
            this.$Util.showChatWithAdmin();
        },
    },
    created() {
        this.checkPermssion = this.$Once(this.checkPermssion)
    }
}
</script>

<style scoped></style>